import { Link } from 'react-router-dom';
import {
  Box,
  Container,
  IconButton,
  Link as MuiLink,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/GridLegacy'
import { Linkedin, Twitter, Github } from 'lucide-react';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        py: { xs: 6, md: 10 },
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          {/* Brand Column */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  bgcolor: 'primary.main',
                }}
              />
              <Typography sx={{ fontWeight: 600, fontSize: '1.25rem' }}>
                prodrelease
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              We release production-ready software teams
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton size="small" sx={{ color: 'text.secondary' }}>
                <Linkedin size={20} />
              </IconButton>
              <IconButton size="small" sx={{ color: 'text.secondary' }}>
                <Twitter size={20} />
              </IconButton>
              <IconButton size="small" sx={{ color: 'text.secondary' }}>
                <Github size={20} />
              </IconButton>
            </Box>
          </Grid>

          {/* Company Column */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{ fontSize: '1rem', fontWeight: 600, mb: 2 }}
            >
              Company
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <MuiLink
                component={Link}
                to="/contact"
                color="text.secondary"
                underline="hover"
                sx={{ fontSize: '0.938rem' }}
              >
                Contact
              </MuiLink>
            </Box>
          </Grid>

          {/* Contact Column */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{ fontSize: '1rem', fontWeight: 600, mb: 2 }}
            >
              Contact
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Typography variant="body2" color="text.secondary">
                hello@prodrelease.com
              </Typography>
              <Typography variant="body2" color="text.secondary">
                +1 (555) 123-4567
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Footer Bottom */}
        <Box
          sx={{
            borderTop: 1,
            borderColor: 'divider',
            mt: 6,
            pt: 4,
          }}
        >
          <Typography variant="body2" color="text.secondary" align="center">
            © {new Date().getFullYear()} prodrelease. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}